import { Timestamp } from "firebase/firestore";

export class TravelGuide {
    _id: string | null;
    name: string;
    description: string;
    longDescription?: string;
    urlCovers: string[];
    tags?: string[];
    price: string;
    likes?: string[]; // array de user IDs
    numberOfLikes?: number; // contador rápido
    contactWhatsApp: ContactWhatsApp;
    creationDate: Timestamp;
    isActive: Boolean;
    mainCityRegionId: string;
    targetAudience: 'solo' | 'family' | 'friends' | 'couple'; // Público objetivo
    numberOfDays: number; // Número de días
    tripTypes: ('adventure' | 'relax' | 'disconnect' | 'trendy' | 'unknown' | 'photography')[]; // Tipo de viaje
    countLikes?: number;

    constructor(travelGuideData: any) {
        this._id = travelGuideData._id;
        this.name = travelGuideData.name;
        this.description = travelGuideData.description;
        this.longDescription = travelGuideData.longDescription;
        this.urlCovers = travelGuideData.urlCovers;
        this.tags = travelGuideData.tags;
        this.price = travelGuideData.price;
        this.likes = travelGuideData.likes;
        this.numberOfLikes = travelGuideData.numberOfLikes;
        this.contactWhatsApp = travelGuideData.contactWhatsApp;
        this.creationDate = travelGuideData.creationDate;
        this.isActive = travelGuideData.isActive;
        this.mainCityRegionId = travelGuideData.mainCityRegionId;
        this.targetAudience = travelGuideData.targetAudience;
        this.numberOfDays = travelGuideData.numberOfDays;
        this.tripTypes = travelGuideData.tripTypes;
        this.countLikes = travelGuideData.countLikes || 0;
    
    }
}



export class ContactWhatsApp{
  countryCode: string;
  dialCode: string;
  e164Number: string;
  internationalNumber: string;
  nationalNumber: string;
  number: string;
}


export class TravelGuideLike {
  likeId: string;
  userId: string;
  travelGuideId: string;
}
